import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-197">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-yellow-400 shadow-2xl" data-id="element-198">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E] uppercase" data-id="element-199">
          Todo lo que recibes hoy
        </h2>

        <div className="mb-4" data-id="element-200">
          <h3 className="text-2xl font-bold mb-3" data-id="element-201">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-xl pl-4" data-id="element-202">
            <li className="flex items-center font-bold" data-id="element-203">
              <span className="text-yellow-400 mr-3" data-id="element-204">•</span> Megapack Inclusión
              Educativa (1° a 6° grado)
            </li>
            <li className="flex items-center" data-id="element-205">
              <span className="text-yellow-400 mr-3" data-id="element-206">•</span> BONUS 1: Kit de
              Regulación Emocional
            </li>
            <li className="flex items-center" data-id="element-207">
              <span className="text-yellow-400 mr-3" data-id="element-208">•</span> BONUS 2: Tableros
              Visuales y Apoyos
            </li>
            <li className="flex items-center" data-id="element-209">
              <span className="text-yellow-400 mr-3" data-id="element-210">•</span> BONUS 3: Atención,
              Memoria y Foco
            </li>
            <li className="flex items-center" data-id="element-211">
              <span className="text-yellow-400 mr-3" data-id="element-212">•</span> BONUS 4: Cuaderno
              de Autonomía
            </li>
            <li className="flex items-center" data-id="element-213">
              <span className="text-yellow-400 mr-3" data-id="element-214">•</span> BONUS 5:
              Planificador Docente Inclusivo
            </li>
            <li className="flex items-center" data-id="element-215">
              <span className="text-yellow-400 mr-3" data-id="element-216">•</span> BONUS 6: Pausas
              Activas y Regulación en el Aula
            </li>
            <li className="flex items-center font-bold text-yellow-400" data-id="element-217">
              <span className="mr-3" data-id="element-218">👑</span> BONUS PREMIUM: Juegos Pedagógicos
              Inclusivos
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-219">
          <h3 className="text-2xl font-bold mb-3" data-id="element-220">Además tendrás:</h3>
          <ul className="space-y-2 text-lg" data-id="element-221">
            <li className="flex items-start" data-id="element-222">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-223" />
              <span data-id="element-224">Más de 600 actividades adaptadas listas para usar</span>
            </li>
            <li className="flex items-start" data-id="element-225">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-226" />
              <span data-id="element-227">
                Material visual, accesible y con menor sobrecarga cognitiva
              </span>
            </li>
            <li className="flex items-start" data-id="element-228">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-229" />
              <span data-id="element-230">
                Recursos multinivel para distintos ritmos de aprendizaje
              </span>
            </li>
            <li className="flex items-start" data-id="element-231">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-232" />
              <span data-id="element-233">
                Ahorro de horas en planificación y adaptación de actividades
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}